import React, { Component } from 'react';
import Feed from './feed';
import SocialLinks from './social';

import logo from '../assets/logo.jpeg';

class Splash extends Component {
    constructor(props) {
        super(props);
        this.navigateToFeed = this.navigateToFeed.bind(this);
    }

    navigateToFeed() {
        this.props.navigateToPage("feed");
    }

    render() {
        return (
            <header className="App-header one-pager">
                <img style={{ maxWidth: "500px", height: "auto", width: "100%", padding:"0" }} src={logo} className="App-logo" alt="logo" />
                <h1 className="pod-headline">The comedy podcast where we teach a lot and lie a little</h1>
                <p  className="pod-description">Join us each week as Charissa or Renee teach the other everything about a topic &mdash; with just one complete and total lie</p>
                <SocialLinks></SocialLinks>
                <Feed></Feed>
            </header>
        )
    }
}
export default Splash; 